import React from 'react';

function RenderCardHeader(props) {
  const { children } = props;
  return <div>{children}</div>;
}

export default RenderCardHeader;
